import { render, staticRenderFns } from "./download-page.vue?vue&type=template&id=39b1dba1&scoped=true"
import script from "./download-page.vue?vue&type=script&lang=js"
export * from "./download-page.vue?vue&type=script&lang=js"
import style0 from "./download-page.vue?vue&type=style&index=0&id=39b1dba1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b1dba1",
  null
  
)

export default component.exports